import { TemplateLink } from "./TemplateLink"

export default function WwwContent() {
  return (
    <>
      <h2>Origin &amp; history</h2>
      <p>
        What Went Well, What Didn't, What Can Improve is the retrospective
        format so ubiquitous that no one bothers to credit it. It's the
        format you invent independently on your first day of facilitating,
        the one that gets written on whiteboards at bootcamps and inside
        Fortune 500 conference rooms with equal frequency. It works because
        the three questions <em>are</em> the three questions.
      </p>

      <h2>When to use this format</h2>
      <p>
        Use it for a team's very first retro, or when a new facilitator is
        finding their feet. It requires zero pre-teaching; everyone knows
        what the three columns mean the moment they see them. The
        low-friction entry is the whole point.
      </p>

      <h2>When NOT to use this format</h2>
      <p>
        Skip it once your team is comfortable. WWW is almost identical to{" "}
        <TemplateLink to="start-stop-continue">Start / Stop / Continue</TemplateLink>{" "}
        in the shape of conversation it produces, and running two
        near-identical formats in rotation is just rebranding. Graduate to
        something with more structure or a different lens (
        <TemplateLink to="sailboat">Sailboat</TemplateLink>,{" "}
        <TemplateLink to="starfish">Starfish</TemplateLink>,{" "}
        <TemplateLink to="mad-sad-glad">Mad / Sad / Glad</TemplateLink>)
        once the team has a few retros under its belt.
      </p>

      <h2>How to run it</h2>
      <p>
        Ten minutes silent writing across all three columns simultaneously.
        Group similar items. Discuss "Didn't Go Well" and "Can Improve"
        together; they're often the same items looked at from two angles.
        End with a quick "Went Well" celebration lap and assign one owner
        for the top Improve item.
      </p>

      <h2>Common pitfalls</h2>
      <p>
        The "Can Improve" column becomes a synonym for "Didn't Go Well"
        with softer wording. If your Improve items are all "we should
        [thing that didn't happen]," you're duplicating. Push people to
        write Improve items that are novel; new practices to try, not
        laments about old ones to fix.
      </p>
    </>
  )
}
